import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import logo from "../../assets/OSM-logo.png"; // pas aan indien nodig
import { useNavigate } from "react-router-dom";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/dashboard");
        } catch (err) {
            alert("Inloggen mislukt: " + err.message);
        }
    };
    const handleResetPassword = async () => {
        if (!email) {
            return alert("Vul eerst je e-mailadres in.");
        }

        try {
            await sendPasswordResetEmail(auth, email);
            alert("Wachtwoord reset-link is verzonden naar " + email);
        } catch (err) {
            console.error(err);
            alert("Kon geen reset-link verzenden: " + err.message);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
                <div className="flex flex-col items-center mb-6">
                    <img src={logo} alt="Logo" className="h-12 mb-2"/>
                    <h2 className="text-2xl font-semibold text-gray-800">Inloggen</h2>
                </div>
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Email</label>
                        <input
                            type="email"
                            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Wachtwoord</label>
                        <input
                            type="password"
                            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
                    >
                        Inloggen
                    </button>
                    <div className="text-center">
                        <button
                            type="button"
                            onClick={handleResetPassword}
                            className="text-sm text-blue-600 hover:underline mt-1"
                        >
                            Wachtwoord vergeten?
                        </button>
                    </div>
                </form>
                <p className="mt-4 text-sm text-center text-gray-600">
                    Nog geen account?{" "}
                    <a
                        href="/register"
                        className="text-blue-600 hover:underline"
                    >
                        Meld je aan
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Login;
